import { callApi } from 'utils/api/callApi'
import { FP_ENDPOINTS } from 'apps/fleet-planner/config'
import { ILoad } from 'apps/fleet-planner/types'

/**
 * Updates tractor VIN
 * @method PUT
 */
export const updateTractor = (id: string, tractorVin: string): Promise<ILoad> => {
  return callApi({
    method: 'PUT',
    endpoint: FP_ENDPOINTS.loads,
    id,
    group: 'tractor',
    body: {
      shipment: {
        tractorVin,
      },
    },
  })
}
